import React from 'react';
import { Box, IconButton, TextField, Typography, Modal } from '@mui/material';
import { Close } from '@mui/icons-material';

interface RenameSessionModalProps {
  open: boolean;
  onClose: () => void;
  renameValue: string;
  onRenameValueChange: (value: string) => void;
  onConfirm: () => void;
}

const RenameSessionModal: React.FC<RenameSessionModalProps> = ({
  open,
  onClose,
  renameValue,
  onRenameValueChange,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          width: '650px',
          outline: 'none',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '8px 8px 0 0',
            p: 2,
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#1A55F9',
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#FFFFFF',
              fontFamily: 'Poppins',
            }}
          >
            Rename Session
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: '#FFFFFF',
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ p: 2.5 }}>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}
          >
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: '#000000',
                fontFamily: 'Poppins',
              }}
            >
              Session name
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: renameValue.trim().length > 100 ? '#EF4444' : '#6b7280',
                fontFamily: 'Poppins',
              }}
            >
              {renameValue.trim().length}/100
            </Typography>
          </Box>
          <TextField
            fullWidth
            value={renameValue}
            onChange={(e) => onRenameValueChange(e.target.value)}
            placeholder="Untitled"
            autoFocus
            inputProps={{
              maxLength: 100,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '16px',
                fontFamily: 'Poppins',
                color: '#000000',
                '& fieldset': {
                  borderColor: '#e5e7eb',
                },
                '&:hover fieldset': {
                  borderColor: '#d1d5db',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#1A55F9',
                  borderWidth: '1px',
                },
              },
            }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
            p: 2.5,
            borderTop: '1px solid #e5e7eb',
          }}
        >
          <Box
            onClick={onClose}
            sx={{
              px: 3,
              py: 1,
              borderRadius: '6px',
              cursor: 'pointer',
              background: '#f3f4f6',
              color: '#000000',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Poppins',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: '#e5e7eb',
              },
            }}
          >
            Cancel
          </Box>

          <Box
            onClick={renameValue.trim() ? onConfirm : undefined}
            sx={{
              px: 3,
              py: 1,
              borderRadius: '6px',
              cursor: 'pointer',
              background: '#1A55F9',
              color: '#FFFFFF',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Poppins',
              opacity: renameValue.trim() ? 1 : 0.5,
              pointerEvents: renameValue.trim() ? 'auto' : 'none',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: '#1543d1',
              },
            }}
          >
            Rename
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RenameSessionModal;
